(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__edlLabLeadTracking) return;
  window.__edlLabLeadTracking = true;
  var key = 'edl:lab-lead:pending';
  var ttl = 30 * 60 * 1000;

  function readPending() {
    try {
      var pending = JSON.parse(sessionStorage.getItem(key));
      if (pending && typeof pending.id === 'string' &&
          /^[a-f0-9-]{36}$/.test(pending.id) &&
          Number.isFinite(pending.at) && Date.now() >= pending.at &&
          Date.now() - pending.at < ttl) return pending;
    } catch (error) {}
    return null;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement) ||
        !form.closest('[data-edl-lead-form]') ||
        !form.checkValidity()) return;
    var honeypot = form.elements.namedItem('website');
    if (honeypot && honeypot.value) return;
    try {
      sessionStorage.setItem(key, JSON.stringify({
        id: crypto.randomUUID(), at: Date.now()
      }));
    } catch (error) {}
  }, true);

  function confirmLead() {
    var wrapper = document.querySelector('[data-edl-lead-form]');
    if (!wrapper) return;
    if (wrapper.querySelector('.form-notification.error')) {
      try { sessionStorage.removeItem(key); } catch (error) {}
      return;
    }
    if (!wrapper.querySelector('[data-edl-lead-confirmed]')) return;
    var pending = readPending();
    if (!pending) return;
    var attempts = 0;
    function publish() {
      if (!readPending()) return;
      if (!window.Shopify || !window.Shopify.analytics ||
          typeof window.Shopify.analytics.publish !== 'function') {
        if (++attempts < 40) setTimeout(publish, 250);
        return;
      }
      try {
        sessionStorage.removeItem(key);
        window.Shopify.analytics.publish('edl_lab_lead_submitted', {
          event_id: pending.id
        });
      } catch (error) {}
    }
    publish();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', confirmLead, { once: true });
  } else {
    confirmLead();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["facility-photo-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialized = new WeakSet();
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function init(root) {
      root.querySelectorAll('.facility-photo-slider').forEach((slider) => {
        if (initialized.has(slider)) return;
        initialized.add(slider);

        const track = slider.querySelector('.facility-photo-slider__track');
        if (!track.querySelector('.facility-photo-slider__card')) return;

        let pausedUntil = 0;
        let target = null;
        let settle = 0;
        // Endless loop: at an end the strip no longer rewinds; the photo that left one end moves to the
        // other, so clicks and autoplay keep going the same way.
        // Snapping is off while the strip moves on its own: after a photo is moved, the browser would
        // otherwise snap back to the photo it had snapped to and cancel the slide. It comes back once the
        // strip stops, so swiping by hand still snaps.
        const release = () => {
          target = null;
          track.style.scrollSnapType = '';
        };
        const step = (direction) => {
          track.style.scrollSnapType = 'none';
          if (target !== null) track.scrollTo({ left: target, behavior: 'auto' }); // a click during a slide lands it first
          const card = track.querySelector('.facility-photo-slider__card');
          const distance = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 12);
          const end = track.scrollWidth - track.clientWidth;
          // Moving a photo keeps the view still: the first visible photo stays where it was on screen
          // (browsers may re-snap by themselves after the change, so measure instead of assuming).
          const keepView = (move) => {
            const edge = track.getBoundingClientRect().left;
            const ref = Array.from(track.children).find((c) => c.getBoundingClientRect().right > edge + 1);
            const before = ref.getBoundingClientRect().left;
            move();
            track.scrollBy({ left: ref.getBoundingClientRect().left - before, behavior: 'auto' });
          };
          // Move a photo one step early, so the strip never stops against its hard end.
          if (direction > 0 && track.scrollLeft + 2 * distance > end + 1) {
            keepView(() => track.append(card));
          } else if (direction < 0 && track.scrollLeft - distance < -1) {
            keepView(() => track.prepend(track.lastElementChild));
          }
          target = Math.max(0, Math.min(track.scrollWidth - track.clientWidth, track.scrollLeft + direction * distance));
          track.scrollTo({ left: target, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
          window.clearTimeout(settle);
          settle = window.setTimeout(release, 1500);
        };
        track.addEventListener('scrollend', () => {
          if (target !== null && Math.abs(track.scrollLeft - target) < 2) {
            window.clearTimeout(settle);
            release();
          }
        });

        slider.querySelectorAll('[data-direction]').forEach((button) => {
          button.addEventListener('click', () => {
            pausedUntil = Date.now() + 6000;
            step(button.dataset.direction === 'next' ? 1 : -1);
          });
        });

        track.addEventListener('pointerdown', () => { pausedUntil = Date.now() + 6000; });
        track.addEventListener('keydown', () => { pausedUntil = Date.now() + 6000; });

        if (slider.dataset.autoplay === 'true') {
          const timer = window.setInterval(() => {
            if (!slider.isConnected) {
              window.clearInterval(timer);
              return;
            }
            if (document.hidden || reducedMotion.matches || slider.matches(':hover') || slider.contains(document.activeElement) || Date.now() < pausedUntil) return;
            step(1);
          }, 2000);
        }
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => init(document));
    } else {
      init(document);
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
